import React, {useState} from "react";
import {Copy, Eye} from "react-feather";
import notyfApi from "./notyfApi";


export const euroFormat = (value) => {
    return Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
    }).format(value)
}

// Custom password component which copies the text when the eye is pressed
export const DisplayPassword = ({text}) => {
    const [show, setShow] = useState(false)

    const toggle = async () => {
        if (show) return setShow(!show)
        setShow(!show)
        navigator.clipboard.writeText(text)
        notyfApi.success(text + " gekopieerd")
    }

    if (!text) return <></>
    return <span><Eye className={"cursor-pointer me-2"} onClick={() => toggle()}/> {show ? text : "****"}</span>
}

// Custom copy text component which copies text when symbol is clicked
export const TextWithCopy = ({text}) => {
    const copy = async () => {
        navigator.clipboard.writeText(text)
        notyfApi.success(text + " gekopieerd")
    }

    if (!text) return <></>
    return <span> <Copy className={"cursor-pointer me-2"} onClick={() => copy()}/>{text}</span>
}


// Make a link out of any text
export const parseLink = link => link.startsWith("http://") || link.startsWith("https://") ? link : `//${link}`;